import { useTranslation } from 'react-i18next'

import { PlusIcon, XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, ComboBox, InputWithLabel, Text, TrolleyIcon } from '@reveni-io/reveni-ui'

import { addProductLocation, getLocationError, removeProductLocation, updateProductLocation } from './helpers'
import * as Styles from './styles'

const ProductLocations = ({ productLocations = [], locations, onChange }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleAddProductLocation = () => {
    onChange(addProductLocation(productLocations))
  }

  const handleRemoveProductLocation = index => {
    onChange(removeProductLocation(productLocations, index))
  }

  const handleUpdateProductLocation = (index, field, value) => {
    onChange(updateProductLocation(productLocations, index, field, value))
  }

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <TrolleyIcon size={24} />
        <Text type="bodyMBold">{t('Ubicación de producto')}</Text>
      </Styles.TitleContainer>
      {productLocations?.map((productLocation, index) => (
        <Styles.ProductLocationRow key={index}>
          <ComboBox
            label={t('Almacén/Tienda')}
            value={productLocation?.location_id}
            handleChange={e => handleUpdateProductLocation(index, 'location_id', e.target.value)}
            menuItems={locations?.map(location => ({
              value: location.id,
              label: location.internal_name || location.public_name,
            }))}
            backgroundColor={theme.colors.background.primary}
            fullWidth
            error={getLocationError(productLocation)}
            helperText={t(getLocationError(productLocation)) || ' '}
          />
          <InputWithLabel
            label={t('Detalles (p. ej., Pasillo 3, Estantería 5)')}
            value={productLocation.details || ''}
            onChange={e => handleUpdateProductLocation(index, 'details', e.target.value)}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
          <Button
            variant="text"
            onClick={() => handleRemoveProductLocation(index)}
            data-testid="remove-product-location-button"
          >
            <XIcon size={16} />
          </Button>
        </Styles.ProductLocationRow>
      ))}
      <div>
        <Button variant="text" onClick={handleAddProductLocation}>
          <PlusIcon size={16} />
          {t('Añade ubicación de producto')}
        </Button>
      </div>
    </Styles.Container>
  )
}

export default ProductLocations
